import { Injectable, NgZone } from '@angular/core';
import { AuthModel } from '../models/auth.model';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { tap } from 'rxjs/operators';
import { ApiService } from './api.service';
// import { shareReplay } from 'rxjs/operators';

@Injectable()
export class AuthService {

  constructor(private apiService: ApiService,
              private ngZone: NgZone) {
  }

  login(email: string, password: string) {
    return this.apiService.post('/login', {email, password})
      .pipe(
      tap(res => this.setSession)
//      .shareReplay();
  );
  }

  setSession(authResult) {
    const expiresAt = moment().add(authResult.expiresIn, 'second');

    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', JSON.stringify(expiresAt.valueOf()) );
  }

  logout() {
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
  }

  public isLoggedIn() {
    return moment().isBefore(this.getExpiration());
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }

  getExpiration() {
    try {
      if (navigator.cookieEnabled) {
        const expiration = localStorage.getItem('expires_at');
        const expiresAt = JSON.parse(expiration);
        return moment(expiresAt);
      } else {
        return moment().subtract(1, 'day');
      }
    } catch (e) {
      return moment().subtract(1, 'day');
    }
  }
}
